import { render, staticRenderFns } from "./AdoptPos.vue?vue&type=template&id=4dc4a103"
import script from "./AdoptPos.vue?vue&type=script&lang=js"
export * from "./AdoptPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports